import api from "./api";

const labRoutineService = {};
const endpoint = "/lab-routines";

labRoutineService.getLabRoutines = function (search = "", isActive = true) {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (isActive !== undefined) params.append("isActive", isActive);

  return api.get(`${endpoint}?${params.toString()}`).then((res) => res.data);
};

labRoutineService.getLabRoutineById = function (id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
};

labRoutineService.getLabRoutine = function (id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
};

labRoutineService.createLabRoutine = function (routineData) {
  return api.post(endpoint, routineData).then(({ data }) => data);
};

labRoutineService.updateLabRoutine = function (id, routineData) {
  return api.put(`${endpoint}/${id}`, routineData).then(({ data }) => data);
};

labRoutineService.deleteLabRoutine = function (id) {
  return api.delete(`${endpoint}/${id}`).then(({ data }) => data);
};

export default labRoutineService;
